/**
 * @generated SignedSource<<1f71aadae0acf505d9c795a09a10b92d>>
 * @relayHash 1089da9c1b827450978f8b7252230ad8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 407eed77e1c5359d6450638bdc6621e6fdfc5fe204896007d0db8bee08bed2a4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type OverviewNotFoundSpaceQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type OverviewNotFoundSpaceQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type OverviewNotFoundSpaceQuery = {
  response: OverviewNotFoundSpaceQuery$data;
  variables: OverviewNotFoundSpaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OverviewNotFoundSpaceQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OverviewNotFoundSpaceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1089da9c1b827450978f8b7252230ad8",
    "id": "407eed77e1c5359d6450638bdc6621e6fdfc5fe204896007d0db8bee08bed2a4",
    "metadata": {},
    "name": "OverviewNotFoundSpaceQuery",
    "operationKind": "query",
    "text": "query OverviewNotFoundSpaceQuery($spaceKey:String){space(key:$spaceKey){id,name}}"
  }
};
})();

(node as any).hash = "20f910bdcabfe9189b1ca218aee5d179";

export default node;
